type RetryOpts = {
  tentativas?: number;
  delayMs?: number;
  rotulo?: string;
};

export async function retry<T>(
  fn: () => Promise<T>,
  opts?: RetryOpts,
): Promise<T> {
  const { tentativas = 3, delayMs = 300, rotulo = "operacao" } = opts ?? {};
  let ultimoErro: unknown;
  for (let i = 0; i < tentativas; i++) {
    try {
      return await fn();
    } catch (err) {
      ultimoErro = err;
      const status = (err as any)?.response?.status;
      if (status === 401 || status === 403) throw err;
      console.warn(
        `[retry] ${rotulo} falhou tentativa ${i + 1}/${tentativas}`,
        err,
      );
      if (i < tentativas - 1) {
        await new Promise((r) => setTimeout(r, delayMs * Math.pow(2, i)));
      }
    }
  }
  throw ultimoErro;
}
